import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSessionGuard } from '../hooks/useSessionGuard';
import WaitingRoom from '../containers/pages/WaitingRoom';
import { IGlobalStoreState } from '../store';
import { heartBeat } from '../services/sessionService';

export const SessionGuard = ({ children }: { children: React.ReactNode }) => {
  const useQueue = useSelector<IGlobalStoreState, boolean>((state) => state.appSettings.useQueue);
  const sessionId = useSelector<IGlobalStoreState, string | null>((state) => state.queue?.sessionId);
  const queueEmail = useSelector<IGlobalStoreState, string>((state) => state.queue?.queueEmail);
  const isAppReadyToBook = useSelector<IGlobalStoreState, boolean>((state) => state.queue?.isReadyToBook);

  const isStartQueue = useQueue && !isAppReadyToBook && !!sessionId && !!queueEmail;
  const { position, isBlocked } = useSessionGuard(isStartQueue, sessionId, useQueue, queueEmail);

  useEffect(() => {
    if (useQueue && sessionId && queueEmail) {
      const sessionHeatBeat = async () => {
        await heartBeat(sessionId, queueEmail);
      };
      const intervalId = setInterval(sessionHeatBeat, 20000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [useQueue, sessionId, queueEmail]);

  if (useQueue && !isAppReadyToBook) {
    return <WaitingRoom isBlocked={isBlocked} queueEmail={queueEmail} position={position} sessionId={sessionId} />;
  }

  return <>{children}</>;
};
